import { render, staticRenderFns } from "./Origin.vue?vue&type=template&id=411dd3d1&scoped=true"
import script from "./Origin.vue?vue&type=script&lang=js"
export * from "./Origin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411dd3d1",
  null
  
)

export default component.exports